import { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import Swal from "sweetalert2";

let url = process.env.REACT_APP_API_URL;

const ShowContactUs = () => {
  const adminToken = localStorage.getItem("token");

  const [contacts, setContacts] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const localeText = {
    noRowsLabel: "No Data Found 😔",
  };

  const columns = [
    { field: "_id", width: 220, headerName: "Id" },
    { field: "name", headerName: "Name", width: 160, filterable: true },
    { field: "email", headerName: "Email", width: 200, filterable: true },
    { field: "phone", headerName: "Phone", width: 140 },
    { field: "subject", headerName: "Subject", width: 180 },
    { field: "message", headerName: "Message", width: 320 },
    {
      field: "createdAt",
      headerName: "Date",
      width: 140,
      valueGetter: (params) =>
        params.value ? new Date(params.value).toLocaleDateString("en-IN") : "",
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Stack direction="row">
          <IconButton onClick={() => handleDelete(params.row._id)}>
            <i className="fas fa-trash-alt font-size-16 font-Icon-Del"></i>
          </IconButton>
        </Stack>
      ),
      filterable: false,
      sortable: false,
      hide: false,
    },
  ];

  useEffect(() => {
    async function getContacts() {
      try {
        const res = await axios.get(`${url}/contact/get`, {
          headers: { Authorization: `${adminToken}` },
        });
        if (res?.data?.type !== "success") {
          setContacts([]);
          setErrorMsg(res?.data?.message || "Access denied.");
          setIsLoading(false);
          return;
        }
        setContacts(res?.data?.contacts || []);
        setErrorMsg("");
        setIsLoading(false);
      } catch (error) {
        setErrorMsg(
          error?.response?.data?.message ||
            "Failed to load Retailer Queries.",
        );
        setIsLoading(false);
      }
    }
    getContacts();
  }, []);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${url}/contact/delete/${id}`, {
            headers: { Authorization: `${adminToken}` },
          })
          .then(() => {
            setContacts(contacts.filter((d) => d?._id !== id));
            Swal.fire("Success!", "Message has been deleted!", "success");
          })
          .catch(() => {
            Swal.fire("Error!", "Message has not been deleted!", "error");
          });
      }
    });
  };

  const handleMultipleDelete = () => {
    let idsToDelete = selectedRows;
    if (!idsToDelete?.length) return;

    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${url}/contact/deletes`, {
            data: { ids: idsToDelete },
            headers: { Authorization: `${adminToken}` },
          })
          .then(() => {
            setContacts(
              contacts?.filter((d) => !idsToDelete?.includes(d?._id)),
            );
            Swal.fire("Success!", "Messages have been deleted!", "success");
          })
          .catch(() => {
            Swal.fire("Error!", "Messages have not been deleted!", "error");
          });
      }
    });
  };

  const handleFilter = () => {
    const filtered = contacts?.filter((item) => {
      const formattedSearchQuery = searchQuery.toLowerCase().replace(/\s/g, "");
      const rowValues = Object.values(item);
      for (let i = 0; i < rowValues.length; i++) {
        const formattedRowValue = String(rowValues[i] || "")
          .toLowerCase()
          .replace(/\s/g, "");
        if (formattedRowValue.includes(formattedSearchQuery)) {
          return true;
        }
      }
      return false;
    });
    return filtered;
  };

  const getRowId = (row) => row._id;

  const handleCellClick = (params, event) => {
    if (event.target.type !== "checkbox") {
      event.stopPropagation();
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-3 table-heading">Retailer Queries</div>
            <div className="d-flex flex-wrap gap-2 mt-2"></div>
            {errorMsg && (
              <div className="alert alert-danger mt-2 mb-2" role="alert">
                {errorMsg}
              </div>
            )}
            <div className="searchContainer mb-3">
              <div className="searchBarcontainer">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="searchBar"
                />
                <ClearIcon
                  className="cancelSearch"
                  onClick={() => setSearchQuery("")}
                />
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-danger"
                  onClick={handleMultipleDelete}
                >
                  Delete Selected
                </button>
              </div>
            </div>

            <div style={{ height: 600, width: "100%" }}>
              <DataGrid
                rows={handleFilter()}
                columns={columns}
                getRowId={getRowId}
                checkboxSelection
                disableSelectionOnClick
                onSelectionModelChange={(ids) => setSelectedRows(ids)}
                onCellClick={handleCellClick}
                loading={isLoading}
                components={{ Toolbar: GridToolbar }}
                localeText={localeText}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowContactUs;
